import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { financeModule } from '../..';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';

type FinanceRootLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const FinanceRootLayout = ({
  children,
  className,
}: FinanceRootLayoutProps) => (
  <ModuleLayout
    moduleNavigation={financeModule.nav}
    noContentPadding={true}
    className={cn('@FinanceRootLayout', className)}
  >
    {children}
  </ModuleLayout>
);
